const PRIMARY_COLOR = "#007bff";
export const dentalRobotTheme = {
  primary: PRIMARY_COLOR,
  secondary: "#0080C0",
  lightGray: "#c1c2c2",
  darkGray: "#444444",
  black: "#040404",
  white: "#ffffff",
  circleButton: "#0080C0",
  fontFamily: "Roboto, sans-serif",
  breadCrumb: {
    color: PRIMARY_COLOR,
    hover: "#0056b3",
  },
  hoverPrimaryClassButton: "theme-dental-primary-button",
  hoverSecondaryClassButton: "theme-secondary-button",
  hoverActionClassButton: "theme-dental-action-button",
  hoverLoginClassButton: "theme-dental-login-button",
  selected: {
    backgroundColor: PRIMARY_COLOR,
    afterBackgroundColor: "#3e8ef7",
    hover: "#d9e9ff",
  },
  checkboxClass: "theme-dental-checkbox",
  fullSizeLogo: "../logo.png",
  miniSizeLogo: "../logo2.png",
  loginBg: "../login.jpg",
  outlinedButtonClass: "theme-dental-outlined-button",
  borderClass: "border-primary",
  pageBrandInfoMargin: "350px 100px 0 90px !important",
  brandImageBig: "/logo-big.png",
  brandImage: "/logo3.png",
  selectClass: "theme-dental-select",
  pageTitleColor: "#37474f",
  menuCategoryColor: "#76838f",
  menuSideBarColor: "#263238",
  activeLinkColor: "rgb(0 0 0 / 6%)",
  sideSubMenuColor: "#242f35",
};
